import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,TiersService } from '../../../../../services'
import { PrintDialog } from '../../../layout/dialogs/print-dialog/print-dialog.component'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'dossier-adresses'

@Component({
  selector: 'atyl-dossier-adresses-relations',
  templateUrl: './dossier-adresses-relations.component.html',
  styleUrls: ['./dossier-adresses-relations.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-adresses',
  key: KEY,
})
export class DossierAdressesRelationsComponent implements OnInit {

    @Input() loading:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
  
  @StringableValues(KEY) strings: any
  
  @Input() tiers: any;
  @Input() relations: any;
  @Input() adresse: any;

  activeButton:boolean=true;
  adressesRelations:any[] = [];
  adresseToSend: any = "sans adresse";
  isLoaded: boolean = false;


  constructor(
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private tiersService: TiersService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

    ngOnInit() {
        this.loading.subscribe((loading)=>{
            if (loading) {
                this.setAdressesRelations();
            }
       });
    }

    ngOnChanges(changes: any) {
    }

    setAdressesRelations(){
        if(this.adresse != null){
            this.adresseToSend = this.adresse;
        }
        this.tiersService.getAdressesRelations(this.adresseToSend, this.relations, this.tiers.ID).subscribe(
            (res: JSONRpcResponse) => {
                this.adressesRelations = [];
                if(res.result && res.result.adresses){
                    res.result.adresses.forEach(adr => {      
                        adr.tiers.contactValues = this.getContactValues(adr.tiers)
                        this.adressesRelations.push(adr);
                    });
                    
                }
                console.log("adressesRelations",this.adressesRelations)
                this.detectChanges();
            }
        );
    }

    detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }

    getAdresseHTML(adresse: any) {
		 let add: string[] = [];
      
       
        let rues: string[] = [];
      
        if (adresse.number &&  adresse.number != "0" &&  adresse.number != 0 && adresse.number.length > 0)
          rues.push(adresse.number);
        if (adresse.complement && adresse.complement.length > 0)
          rues.push(adresse.complement);
        if (adresse.street && adresse.street.length > 0)
          rues.push(adresse.street);
        if (rues && rues.length > 0)
          add.push(rues.join(" "));
      
        let ville: string[] = [];
        if (adresse.IDzipcode && adresse.IDzipcode.length > 0)
          ville.push(adresse.IDzipcode);
        if (adresse.town && adresse.town.length > 0)
          ville.push(adresse.town);
        if (adresse.adresse)
          add.push(adresse.adresse);
        if (adresse.adresse2)
          add.push(adresse.adresse2);
      
        if (ville && ville.length > 0)
          add.push(ville.join(" "));
      
        return add.join("<br/>");
    }

    getContactValues(tiers: any){
      var contactsValues = [];
      if(!this.isContactsEmpty(tiers.contacts)){
        Object.keys(tiers.contacts).forEach(key => {
          const contactValue = tiers.contacts[key];
          if(contactValue && contactValue != ""){
            const contactLibelle = tiers.contactsLabel[key] != undefined? tiers.contactsLabel[key]: null;
            const contactType = tiers.contactsType[key] != undefined? tiers.contactsType[key]: null;
            const contactPrincipal = tiers.contactsPrincipal[key] != undefined? tiers.contactsPrincipal[key]: "non";
            const contactOptin = tiers.contactsOptin[key] != undefined? tiers.contactsPrincipal[key]: "non";
            const contact = {
              value: contactValue,
              libelle: contactLibelle,
              type: contactType,
              principal: contactPrincipal,
              optin: contactOptin
            }
            contactsValues.push(contact);
          }
        });
      }
      console.log("contactValues",contactsValues)
      return contactsValues;
    }
  
    isContactsEmpty(contacts: any): boolean {
      if (Array.isArray(contacts)) {
        return true;
      } else if (typeof contacts === 'object') {
        return Object.keys(contacts).length === 0;
      }
      return true;
    }


  
      

}
